import { AiFillLinkedin } from "react-icons/ai";
import Typewriter from "typewriter-effect";
import image from "../assets/image-copy.jpg";
import { motion } from "framer-motion";
import { MdEmail } from "react-icons/md";
import { BsGithub } from "react-icons/bs";
import resume from "../assets/resume.pdf";
import hero from "../assets/hero-bg.png";

export default function Home() {
  return (
    <>
      <section className="px-10 md:px-20 lg:px-32 pb-20 lg:pb-0 min-h-screen">
        <nav className="flex justify-between py-10 mb-12">
          <h1 className="text-xl text-gray-100 font-burtons dark:text-white">
            developedbyme
          </h1>
          <div className="items-center">
            <a
              className="m-4 px-4 py-2 bg-gradient-to-r from-purple-400 to-violet-600 hover:bg-gradient-to-l from-violet-700 to-purple-500 text-white rounded transition-all"
              href={resume}
              target="_blank"
              rel="noreferrer"
            >
              Resume
            </a>
          </div>
        </nav>

        <div className="p-0 lg:p-5 lg:m-10 flex flex-col lg:flex-row">
          <motion.div
            initial={{ opacity: 0, translateY: 300 }}
            animate={{ opacity: 1, translateY: 0 }}
            transition={{
              type: "spring",
              bounce: 0.3,
              duration: 1.1,
            }}
            className="flex flex-col mx-auto text-center  lg:text-left select-none"
          >
            <h2 className="text-7xl py-2 text-violet-400 font-medium md:text-7xl">
              Animesh Sharma
            </h2>
            <h3 className="text-xl py-2 font-bold md:text-3xl text-gray-200">
              <Typewriter
                options={{
                  strings: [
                    "I am FrontEnd Developer",
                    "Creative Graphic Designer",
                  ],
                  autoStart: true,
                  loop: true,
                }}
              />
            </h3>

            <p
              className="py-5 text-md lg:text-xl leading-8 tracking-wide lg:leading-9 text-gray-300 max-w-xl "
              style={{ fontFamily: "Montserrat" }}
            >
             I am an experienced Front-End Developer with over a year of expertise in HTML5, Cascade Style Sheets (CSS3), Javascript, React.Js and Redux. I also possess a strong understanding of Back-End technologies such as MongoDB, Express.js, and Node.js, as well as Full-Stack Frameworks like Next.js. My proficiency in UI/UX design is evident through my skills in Adobe Photoshop, Adobe Illustrator, and Figma. I am always eager to learn and keep myself updated with the latest advancements in technology to constantly improve my skills and stay ahead of the game.
            </p>

            <div className="text-5xl mt-10 mb-10 ml-0 lg:-ml-40 flex justify-center gap-16 text-gray-400 ">
              <a
                className="transition-all hover:scale-110 hover:text-red-600 duration-250"
                href="mailto:animesh8492@gmail.com"
                target="_blank"
                rel="noreferrer"
              >
                <MdEmail />
              </a>
              <a
                className="transition-all hover:scale-110 hover:text-blue-600 duration-250"
                href="https://www.linkedin.com/in/animesh-sharma-a74595250/"
                target="_blank"
                rel="noreferrer"
              >
                <AiFillLinkedin />
              </a>
              <a
                className="transition-all hover:scale-110 hover:text-gray-100 duration-250"
                href="https://github.com/hashZero1"
                target="_blank"
                rel="noreferrer"
              >
                <BsGithub />
              </a>
            </div>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, translateY: 300 }}
            animate={{ opacity: 1, translateY: 0 }}
            transition={{
              type: "spring",
              bounce: 0.3,
              duration: 1.1,
              delay: 0.4,
            }}
            className="relative w-full mt-0 lg:w-[50%] mx-auto lg:mt-20 2xl:mt-0"
          >
            <img className="opacity-[95%]" src={hero} alt="" />
            {/* <img
              className="absolute lg:top-20 lg:left-60 lg:w-96 opacity-80 drop-shadow-xl"
              src={image}
              alt=""
              style={{ borderRadius: "20% 30% 10% 30%" }}
            /> */}
          </motion.div>
        </div>
      </section>
    </>
  );
}
